// affiliate-community
export const AFFILIATES_FINDER_PATH = '/affiliates/affiliates-finder';
export const MY_COMMUNITY_PATH = '/affiliates/my-community';
export const MY_LISTS_PATH = '/affiliates/my-lists';
export const ADD_CREATORS_FROM_COMMUNITY_PATH = '/affiliates/my-lists/editing';

// campaign setup
export const COLLABORATION_REVIEW_PATH = '/collaborations/collaboration-review';
export const TTS_CAMPAIGN_SETUP_PATH = '/collaborations/campaign-setup/tiktok-shop';
export const YTS_CAMPAIGN_SETUP_PATH = '/collaborations/campaign-setup/youtube-shopping';

// samples management
export const TTS_SAMPLES_MANAGEMENT_PATH = '/collaborations/samples-management/tiktok-shop';
export const YTS_SAMPLES_MANAGEMENT_PATH = '/collaborations/samples-management/youtube-shopping';

// crm
export const CREATE_SEQUENCE_PATH = '/crm/create-sequence';
export const DUPLICATE_SEQUENCE_PATH = '/crm/duplicate-sequence';
export const EDIT_SEQUENCE_PATH = '/crm/edit-sequence';
export const MY_SEQUENCES_PATH = '/crm/my-sequences';
export const MY_TEMPLATES_PATH = '/crm/my-templates';

// data analytics
export const TTS_DATA_ANALYTICS_PATH = '/data-analytics/tiktok-shop';
export const YTS_DATA_ANALYTICS_PATH = '/data-analytics/youtube-shopping';

// settings
export const SETTINGS_PATH = '/settings';

// profile
export const BILLING_PAYMENTS_PATH = '/profiles/billing/payments';
export const BILLING_PAYMENT_METHODS_PATH = '/profiles/billing/payment-methods';
export const MY_ACCOUNT_PATH = '/profiles/account/my-account';
export const PRICING_PATH = '/profiles/account/pricing';

// payments
export const ADD_PAYMENT_PATH = '/add-payment';
